<template>
  <div v-if="this.hasLandowner(rowData)">
    <h3>Agreement Details</h3>
    <table class="el-table">
      <thead>
        <tr>
          <th>Item</th>
          <th>Date</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tfoot>
      </tfoot>
      <tbody>
        <tr>
          <td>{{localSite.landType}} Agreement</td>
          <td>{{formatDate(localSite.landStarted)}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Deposit Paid</td>
          <td></td>
          <td>{{formatNumber(localSite.landDeposit)}}</td>
        </tr>
        <tr>
          <td>{{localSite.landPaymentFrequency}} Rental</td>
          <td></td>
          <td>{{formatNumber(localSite.landValue)}}</td>
        </tr>
        <tr>
          <td>Agreement Expiry</td>
          <td><strong>{{formatDate(localSite.landExpiry)}}</strong> <i>({{formatFriendlyDate(localSite.landExpiry)}})</i></td>
          <td></td>
        </tr>
        <tr>
          <td>Renewal Increment</td>
          <td>
            <span v-if="localSite.term">
              <strong>{{this.addSuffix(localSite.term)}}</strong> time
            </span>
          </td>
          <td><strong>{{formatNumber(localSite.increment)}}</strong> %</td>
        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localSite: this.rowData
    }
  }
}
</script>



// WEBPACK FOOTER //
// LandAgreement.vue?faea9da6